var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"1","transform":"translate(0.5, 0.5)"},React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"1","strokeLinecap":"square","strokeMiterlimit":"10","d":"M19,15C13.5,15,9,10.5,9,5\n\tc0-0.9,0.1-1.8,0.4-2.6C5.1,3.5,2,7.4,2,12c0,5.5,4.5,10,10,10c4.6,0,8.5-3.1,9.6-7.4C20.8,14.9,19.9,15,19,15z","strokeLinejoin":"miter"})));
}

Moon.defaultProps = {"x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Moon;

Moon.default = Moon;
